var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityPlayedStateButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#D0CCD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9658 10.6942C21.1415 10.87 21.2403 11.1085 21.2403 11.357C21.2403 11.6056 21.1415 11.8441 20.9658 12.0199L13.9389 19.0467C13.846 19.1396 13.7358 19.2133 13.6145 19.2636C13.4931 19.3138 13.3631 19.3397 13.2317 19.3397C13.1004 19.3397 12.9703 19.3138 12.849 19.2636C12.7276 19.2133 12.6174 19.1396 12.5245 19.0467L9.03328 15.5561C8.94374 15.4696 8.87232 15.3662 8.82318 15.2518C8.77405 15.1374 8.74819 15.0144 8.74711 14.8899C8.74602 14.7654 8.76974 14.642 8.81688 14.5268C8.86402 14.4116 8.93363 14.3069 9.02166 14.2189C9.10968 14.1308 9.21436 14.0612 9.32957 14.0141C9.44479 13.9669 9.56824 13.9432 9.69272 13.9443C9.8172 13.9454 9.94022 13.9713 10.0546 14.0204C10.169 14.0695 10.2724 14.1409 10.3589 14.2305L13.2314 17.103L19.6395 10.6942C19.7266 10.6071 19.83 10.538 19.9437 10.4909C20.0575 10.4437 20.1795 10.4194 20.3027 10.4194C20.4258 10.4194 20.5478 10.4437 20.6616 10.4909C20.7753 10.538 20.8787 10.6071 20.9658 10.6942Z",
    fill: "#B8B2C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityPlayedStateButton);
export default __webpack_public_path__ + "static/media/activity-played-state-button.677408b34baf99e3b4ad630dc5b1ad6330a4a844bc860f1bbfe74ee478c94656.svg";
export { ForwardRef as ReactComponent };